export default __webpack_public_path__ + "static/drawer-ctas.pattern-55c4eaa75f423d0ca6c110d19dd93614.svg";